import { Routes } from '@/router/routes'

export const dailyAgendaV2Routes = [
  {
    path: '/daily-agenda-v2',
    name: Routes.DailyAgendaV2,
    redirect: { name: Routes.DailyAgenda },
  },
]
